const selectors = {
  root: '[data-toggle-init]',
  btn: '[data-toggle-btn]'
};

const minButtons = 2;

/**
 * Osmo Toggle Switch, kept as-is in behaviour: the sliding pill is a CSS
 * transform driven by --tabs-active, and the buttons share one tab stop so the
 * arrow keys walk the selection like a real segmented control.
 * Beyond the resource, each root announces a `tabs:ready` event with its API and
 * a bubbling `tabs:change` on user interaction only, so a host block can react
 * to clicks without re-implementing the state.
 */

function initTabs(root) {
  const buttons = [...root.querySelectorAll(selectors.btn)];

  if (buttons.length < minButtons) {
    return;
  }

  root.style.setProperty('--tabs-count', buttons.length);

  let activeIndex = buttons.findIndex(button => button.hasAttribute('data-toggle-active'));

  if (activeIndex < 0) {
    activeIndex = 0;
  }

  function setActive(index) {
    activeIndex = index;
    root.style.setProperty('--tabs-active', index);

    buttons.forEach((button, buttonIndex) => {
      const isActive = buttonIndex === index;

      button.setAttribute('aria-pressed', isActive ? 'true' : 'false');
      button.toggleAttribute('data-toggle-active', isActive);
      button.tabIndex = isActive ? 0 : -1;
    });
  }

  function selectByUser(index) {
    if (index === activeIndex) {
      return;
    }

    setActive(index);

    root.dispatchEvent(new CustomEvent('tabs:change', {
      bubbles: true,
      detail: { index, value: buttons[index].dataset.tabValue }
    }));
  }

  function onClick(event) {
    selectByUser(buttons.indexOf(event.currentTarget));
  }

  function onKeydown(event) {
    const direction = event.key === 'ArrowRight' ? 1 : event.key === 'ArrowLeft' ? -1 : 0;

    if (!direction) {
      return;
    }

    event.preventDefault();

    const next = (activeIndex + direction + buttons.length) % buttons.length;

    selectByUser(next);
    buttons[next].focus();
  }

  buttons.forEach(button => {
    button.addEventListener('click', onClick);
    button.addEventListener('keydown', onKeydown);
  });

  setActive(activeIndex);

  root.dispatchEvent(new CustomEvent('tabs:ready', {
    bubbles: true,
    detail: {
      setActive,
      getActive: () => activeIndex,
      values: buttons.map(button => button.dataset.tabValue)
    }
  }));
}

document.addEventListener('DOMContentLoaded', () => {
  document.querySelectorAll(selectors.root).forEach(initTabs);
});
